import { FloatingTextCSSStyle, FloatingTextCSSStyleImpl } from '../floatingtextcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';


export interface MsisdnFloatingTextCSSStyle extends FloatingTextCSSStyle
{
    getCountryCodeCSSStyle(): object;
    getFloatingErrorTextCSSStyle(isFloatingLabel: boolean): object;
}

export class MsisdnFloatingTextCSSStyleImpl extends FloatingTextCSSStyleImpl implements MsisdnFloatingTextCSSStyle
{
    
    getCountryCodeCSSStyle(): object {
       return {
        fontSize: this.getResources().getFont(Fonts.h9),
        color: this.getResources().getColor(Colors.color_4),
        height: "30px",
        position: "absolute",
        textDecoration: "none",
        border: 0,
        marginTop: "4px",
        fontWeight: 500,
        letterSpacing: 0,
        lineHeight: "20px",
        outline: "none",
        fontFamily: this.getResources().getFontFamily()
       };
    }

    getTextCSSStyle(isFloatingLabel: boolean): object 
    {
        console.log("isFloatingLabel: " + isFloatingLabel);
        if(isFloatingLabel)
        {
            return {
                fontSize: this.getResources().getFont(Fonts.h9),
                color: this.getResources().getColor(Colors.color_4),
                fontFamily: this.getResources().getFontFamily(),
                height: "30px",
                bottom: "3px",
                width: "100%",
                textDecoration: "none",
                borderTop: 0,
                borderRight:0,
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "20px",
                borderBottom: "1px solid " + this.getResources().getColor(Colors.color_39),
                borderLeft:0,
                outline: "none"
            };
        }
        else
        {
            return {
                fontSize: this.getResources().getFont(Fonts.h9),
                fontFamily:this.getResources().getFontFamily(),
                color: this.getResources().getColor(Colors.color_4),
                height: "30px",
                bottom: "3px",
                width: "100%",
                textDecoration: "none",
                borderTop: 0,
                borderRight:0,
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "20px",
                borderBottom: "1px solid " + this.getResources().getColor(Colors.color_39),
                borderLeft:0,
                outline: "none"
            };
        }
    }

    getFloatingErrorTextCSSStyle(isFloatingLabel: boolean): object 
    {
        if(isFloatingLabel)
        {
            return {
                fontSize: this.getResources().getFont(Fonts.h9),
                color: this.getResources().getColor(Colors.color_4),
                height: "30px",
                bottom: "3px",
                textDecoration: "none",
                borderTop: 0,
                borderRight:0,
                fontWeight: 500,
                width: "100%",
                // paddingLeft:"50px",
                // paddingRight: "0px",
                borderBottom: "2px solid " + this.getResources().getColor(Colors.color_11),
                borderLeft:0,
                outline: "none",
                fontFamily: this.getResources().getFontFamily()

            };
        }
        else
        {
            return {
                fontSize: this.getResources().getFont(Fonts.h9),
                color: this.getResources().getColor(Colors.color_4),
                height: "30px",
                bottom: "3px",
                textDecoration: "none",
                borderTop: 0,
                width: "100%",
                borderRight:0,
                fontWeight: 500,
                // paddingLeft: "0px",
                // paddingRight: "0px",
                borderBottom: "2px solid " + this.getResources().getColor(Colors.color_11),
                borderLeft:0,
                outline: "none",
                fontFamily:this.getResources().getFontFamily()

            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcss.tsx